
interface ResourceData {
	Name: string,
	Type: string,
	SerialNumber: string,
	STNumber: string,
	ReferenceNumber: string,
	KindEnum: string | number,
	SAPId: string,
	HRId: string,
	Company: string,
	EmployeeCompany: string,
	ApplicationName: string,
	Department: string,
	GivenName: string,
	Surname: string,
}

export interface IChunk { label: string, title: string };

export function getResourceDescriptionHtml(selector: string): void
{
	var elements = document.querySelectorAll(selector);
	for (let i = 0; i < elements.length; i++) {
		let element = elements[i] as HTMLElement;
		element.innerHTML = resourceLabel({
			Name: element.dataset.name,
			Type: element.dataset.type,
			SerialNumber: element.dataset.serialNumber,
			STNumber: element.dataset.stNumber,
			ReferenceNumber: element.dataset.referenceNumber,
			KindEnum: element.dataset.kind,
			SAPId: element.dataset.sapId,
			HRId: element.dataset.hrId,
			Company: element.dataset.company,
			EmployeeCompany: element.dataset.employeeCompany,
			ApplicationName: element.dataset.applicationName,
			Department: element.dataset.department,
			GivenName: element.dataset.givenName,
			Surname: element.dataset.surname,
		});
	}
}

function formatCreator(resource: ResourceData, transform: (fieldText: string, field: string) => string): string {
	let qdesk = (window as any).qdesk;
	let format: string = qdesk.settings.resourceFormat;

	if (resource.KindEnum === "Application" || resource.KindEnum === 1) {
		let format = qdesk.settings.applicationFormat;
		let propertiesNames = format.split("|");
		var extarcted = extract(propertiesNames, "ApplicationName");
		let beforeText = "";
		if (extarcted.exist && resource.ApplicationName) {
			beforeText = transform(resource.ApplicationName, "ApplicationName") + " - ";
		}
		return beforeText + transform(resource.Name, "Name") + " " + joinElements(resource, extarcted.array, transform);
	}
	if (resource.KindEnum == "Employee" || resource.KindEnum === 7)
		format = qdesk.settings.employeeFormat;
	if (resource.KindEnum == "ServiceAsset" || resource.KindEnum === 18)
		format = "Type";
	if (resource.KindEnum == "Training" || resource.KindEnum === 23)
		format = "Type";
	if (resource.KindEnum == "BusinessProcess" || resource.KindEnum === 24)
		format = "Type";
	if (resource.KindEnum == "DataSet" || resource.KindEnum === 25)
		format = "Type";
	if (resource.KindEnum == "ResourceLocation" || resource.KindEnum === 26)
		format = "Type";
	if (resource.KindEnum == "PersonProfile" || resource.KindEnum === 27)
		format = qdesk.settings.personProfileFormat;

	let propertiesNames = format.split("|");

	return transform(resource.Name, "Name") + " " + joinElements(resource, propertiesNames, transform);
}

function extract(propertiesNames: string[], name: string) {
	let newArray: string[] = [];
	var exist = false;
	for (let i = 0; i < propertiesNames.length; i++){
		if (propertiesNames[i] != name) {
			newArray.push(propertiesNames[i]);
		}
		else
			exist = true;
	}

	return {
		array: newArray,
		exist: exist,
	}
}

function getElements(resource: ResourceData, chunksFormat: string[]): IChunk[] {
	let elements: IChunk[] = [];
	for (let i = 0; i < chunksFormat.length; i++) {

		let title: string[] = [];
		var field: string = chunkToString(resource, chunksFormat[i], (fieldText: string, field: string) => {
			title.push(translateTite(field));
			return fieldText;
		});

		if (field)
			elements.push({
				label: field,
				title: title.join(" "),
			});
	}

	return elements;
}

function joinElements(resource: ResourceData, chunksFormat: string[], transform: (fieldText: string, field: string) => string) {
	let elements: string[] = [];
	for (let i = 0; i < chunksFormat.length; i++) {
		
		var field: string = chunkToString(resource, chunksFormat[i], transform);
		if (field)
			elements.push(field);
	}

	if (elements.length == 0)
		return "";

	return "(" + elements.join("/") + ")";
}

function chunkToString(resource: ResourceData, chunkFormat: string, transform: (fieldText: string, field: string) => string)
{
	let elements: string[] = [];
	var propertiesNames = chunkFormat.split(" ");
	for (let i = 0; i < propertiesNames.length; i++) {
		var propName = propertiesNames[i];
		var field: string = resource[propName];
		if (!field)
			continue;
		field = transform(field, propName);
		elements.push(field);
	}
	
	return elements.join(" ");
}

export function resourceLabel(resource: ResourceData): string {

	return formatCreator(resource, (fieldText: string, field: string) => {

		return '<span title="' + translateTite(field) + '">' + fieldText + "</span>";
	});
}

function translateTite(field: string): string {
	let qdesk = (window as any).qdesk;

	let key = "";
	if (field == "Name") key = "name";
	if (field == "Type") key = "type";
	if (field == "SerialNumber") key = "serialNumber";
	if (field == "STNumber") key = "STNumber";
	if (field == "ReferenceNumber") key = "referenceNumber";
	if (field == "SAPId") key = "SAPId";
	if (field == "HRId") key = "HRId";
	if (field == "Company") key = "Company";
	if (field == "EmployeeCompany") key = "EmployeeCompany";
	if (field == "ApplicationName") key = "ApplicationName";
	if (field == "Department") key = "Department";
	if (field == "GivenName") key = "givenName";
	if (field == "Surname") key = "surname";

	return qdesk.strings[key];
}

export function resourceDescriptionHtml(resource: ResourceData): { name: IChunk[], description: IChunk[] } {

	const qdesk = (window as any).qdesk;
	let format: string = qdesk.settings.resourceFormat;

	let name = [{
		label: resource.Name,
		title: qdesk.strings["Name"],
	}];

	if (resource.KindEnum === "Application" || resource.KindEnum === 1) {
		let format = qdesk.settings.applicationFormat;
		let propertiesNames = format.split("|");
		var extarcted = extract(propertiesNames, "ApplicationName");
		if (extarcted.exist && resource.ApplicationName) {
			name.unshift({
				label: resource.ApplicationName,
				title: translateTite("ApplicationName"),
			});
		}

		return {
			name,
			description: getElements(resource, extarcted.array)
		};
	}
	if (resource.KindEnum == "Employee" || resource.KindEnum === 7)
		format = qdesk.settings.employeeFormat;
	if (resource.KindEnum == "ServiceAsset" || resource.KindEnum === 18)
		format = "Type";
	if (resource.KindEnum == "Training" || resource.KindEnum === 23)
		format = "Type";
	if (resource.KindEnum == "BusinessProcess" || resource.KindEnum === 24)
		format = "Type";
	if (resource.KindEnum == "DataSet" || resource.KindEnum === 25)
		format = "Type";
	if (resource.KindEnum == "ResourceLocation" || resource.KindEnum === 26)
		format = "Type";
	if (resource.KindEnum == "PersonProfile" || resource.KindEnum === 27)
		format = qdesk.settings.personProfileFormat;

	let propertiesNames = format.split("|");

	return {
		name,
		description: getElements(resource, propertiesNames)
	};
}

export function resourceLabelText(resource: ResourceData): string {
	return formatCreator(resource, (fieldText, field) => fieldText);
}

(function (qdesk) {
	(function (ui) {
		(function (util) {
			util.resourceLabel = resourceLabel;
			util.resourceLabelText = resourceLabelText;
			util.getResourceDescriptionHtml = getResourceDescriptionHtml;
		}(ui.util = ui.util || {}));
	} (qdesk.ui = qdesk.ui || {}));
}((window as any).qdesk = (window as any).qdesk || {}));